module.exports = __webpack_public_path__ + "static/media/ios-heart-half.3015bda7.svg";